export { default } from './RastreadoresBannerV2';
